"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useTextInputStyles = exports.textInputVars = exports.textInputCommon = void 0;
var _Text = require("../../components/Text/Text.util");
var _createUseStyles = _interopRequireDefault(require("../../themes/createUseStyles"));
var _Theme = require("../../themes/Theme");
var _commonProps = require("../../utils/vars/commonProps");
var _initVars = _interopRequireDefault(require("../../utils/vars/initVars"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; } /**
 * @copyright
 * Copyright (c) 2025 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
var textInputCommon = exports.textInputCommon = ["width"].concat(_toConsumableArray(_commonProps.defaultCommonProps));
var textInputVars = exports.textInputVars = (0, _initVars.default)({
  applied: textInputCommon,
  variables: [{
    key: "leftIconMarginTweak",
    defaultUnit: "px"
  }, {
    key: "leftIconInputTweak",
    defaultUnit: "px"
  }, {
    key: "inputDisabledAndPlaceholderColor",
    canHaveColor: true
  }, {
    key: "inputDisabledOpacity"
  }, {
    key: "transparentFilter"
  }, {
    key: "iconFillOnHover",
    canHaveColor: true
  }, {
    key: "labelFontSize",
    defaultUnit: "px"
  }, {
    key: "labelTextTransform"
  }]
});
var styles = function styles(theme) {
  return {
    variables: textInputVars.styles,
    root: {
      display: "inline-flex",
      flexFlow: "column",
      width: "100%",
      fontFamily: theme.typography.fontFamily
    },
    input: {
      boxSizing: "border-box",
      background: theme.colors.textOnDark,
      padding: theme.spacing.base,
      fontSize: theme.typography.fontSize,
      WebkitAppearance: "none",
      outline: 0,
      color: theme.colors.textOnLight,
      borderStyle: "solid",
      borderRadius: 2,
      fontWeight: theme.typography.fontWeight,
      fontFamily: "inherit",
      position: "relative",
      transition: "300ms ease-in border-color",
      borderWidth: 1,
      borderColor: theme.colors.baseContrast060,
      width: "100%",
      height: "100%",
      "&:disabled": {
        background: theme.colors.baseContrast020,
        borderColor: theme.colors.baseContrast030,
        color: textInputVars.get("inputDisabledAndPlaceholderColor"),
        opacity: textInputVars.get("inputDisabledOpacity")
      },
      "&:disabled ~ span": {
        borderColor: theme.colors.baseContrast030,
        opacity: textInputVars.get("inputDisabledOpacity")
      },
      "&::placeholder": {
        color: textInputVars.get("inputDisabledAndPlaceholderColor")
      },
      "&:focus-visible": {
        boxShadow: "inset 0 0 2px 1px ".concat(theme.colors.baseInvariant)
      }
    },
    transparent: {
      background: "transparent",
      borderColor: theme.colors.baseContrast030,
      color: theme.colors.baseContrast070,
      "&::-webkit-calendar-picker-indicator": {
        filter: textInputVars.get("transparentFilter")
      }
    },
    prefixPresent: {
      borderStartStartRadius: 0,
      borderEndStartRadius: 0
    },
    suffixPresent: {
      borderStartEndRadius: 0,
      borderEndEndRadius: 0
    },
    preAndSuffix: {
      backgroundColor: theme.mode === _Theme.ThemeMode.dark ? theme.colors.baseContrast085 : theme.colors.baseContrast015,
      color: theme.colors.textOnLight,
      border: "1px solid ".concat(theme.colors.baseContrast060),
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      padding: "0 ".concat(theme.spacing.base * 1.5, "px"),
      boxSizing: "border-box"
    },
    prefix: {
      composes: "$preAndSuffix",
      borderEndStartRadius: "2px",
      borderStartStartRadius: "2px",
      borderInlineEnd: "none"
    },
    suffix: {
      composes: "$preAndSuffix",
      borderEndEndRadius: "2px",
      borderStartEndRadius: "2px",
      borderInlineStart: "none"
    },
    prefixSuffixValidity: {
      borderWidth: 2
    },
    prefixValid: {
      composes: "$prefixSuffixValidity",
      borderColor: theme.colors.success
    },
    prefixInvalid: {
      composes: "$prefixSuffixValidity",
      borderColor: theme.colors.alert
    },
    suffixDefined: {
      composes: "$prefixSuffixValidity"
    },
    border: {
      boxSizing: "border-box",
      position: "absolute",
      top: 0,
      // eslint-disable-next-line @atg/css-rtl-support
      left: 0,
      borderColor: theme.colors.baseContrast060,
      borderWidth: 2,
      borderStyle: "solid",
      borderRadius: 2,
      width: "100%",
      height: "100%",
      pointerEvents: "none",
      transform: "scaleX(0)",
      borderLeftWidth: 0,
      borderRightWidth: 0,
      transition: "500ms linear transform",
      transformOrigin: "center"
    },
    inputWithValue: {
      // we are extracting 1px to account for 2px border
      padding: [theme.spacing.base, theme.spacing.base - 1],
      borderWidth: 2,
      "& ~ span": {
        transform: "scaleX(1)"
      },
      "&:focus-visible ~ svg": {
        display: "inline-block"
      }
    },
    inputWithValuePassword: {
      paddingInlineEnd: theme.spacing.base * 5
    },
    inputWithValidValue: {
      borderLeftColor: theme.colors.success,
      borderRightColor: theme.colors.success,
      "& ~ span": {
        borderColor: theme.colors.success
      },
      "&:focus-visible": {
        boxShadow: "none"
      }
    },
    textareaWithValidValue: {
      borderColor: theme.colors.success,
      "&:focus-visible": {
        boxShadow: "none"
      }
    },
    inputWithInvalidValue: {
      borderLeftColor: theme.colors.alert,
      borderRightColor: theme.colors.alert,
      "& ~ span": {
        borderColor: theme.colors.alert
      },
      "&:focus-visible": {
        boxShadow: "none"
      }
    },
    textareaWithInvalidValue: {
      borderColor: theme.colors.alert,
      "&:focus-visible": {
        boxShadow: "none"
      }
    },
    inputWithLeftIcon: {
      paddingInlineStart: textInputVars.get("leftIconInputTweak")
    },
    inputWithRightIcon: {
      paddingInlineEnd: theme.spacing.base * 5
    },
    label: {
      fontFamily: "inherit",
      fontSize: textInputVars.get("labelFontSize", theme.typography.fontSize - 1),
      textTransform: textInputVars.get("labelTextTransform", "none"),
      fontWeight: theme.typography.fontWeight,
      color: theme.colors.baseContrast060,
      paddingBottom: theme.spacing.base / 2,
      lineHeight: 1.4
    },
    errorText: _objectSpread({
      fontFamily: "inherit",
      marginTop: theme.spacing.base / 2,
      marginBottom: 0
    }, (0, _Text.setTextCssVars)({
      color: theme.colors.alert,
      fontSize: theme.typography.fontSize - 1,
      fontWeight: 600
    })),
    container: {
      alignItems: "center",
      display: "flex",
      position: "relative",
      "& > svg": {
        animation: "$StateIconFadeIn 700ms linear",
        cursor: "text",
        marginInlineStart: theme.spacing.base * -4,
        zIndex: 1
      }
    },
    icon: {
      zIndex: 2,
      "& :first-child": {
        maxHeight: theme.spacing.base * 4.5
      }
    },
    leftIcon: {
      extend: "icon",
      marginInlineEnd: textInputVars.get("leftIconMarginTweak"),
      "& > *": {
        marginInlineStart: "".concat(theme.spacing.base, "px !important")
      }
    },
    rightIcon: {
      extend: "icon",
      marginInlineStart: -(theme.spacing.base * 5),
      "& > svg": {
        width: "40px"
      },
      "& svg": {
        fill: theme.colors.baseContrast050
      },
      "& [type='button'] svg": {
        fill: theme.colors.primary
      },
      "& [type='button']:hover svg": {
        fill: theme.colors.primaryDark
      },
      "&:hover svg": {
        fill: textInputVars.get("iconFillOnHover")
      }
    },
    disabledIcon: {
      pointerEvents: "none",
      cursor: "default",
      borderColor: theme.colors.baseContrast030,
      "& svg, & [type='button'] svg": {
        fill: theme.colors.baseContrast030
      }
    },
    "@keyframes StateIconFadeIn": {
      "0%": {
        opacity: 0
      },
      "100%": {
        opacity: 100
      }
    },
    hint: {
      fontSize: theme.typography.fontSize - 2,
      fontWeight: theme.typography.fontWeight,
      color: theme.colors.baseContrast050
    },
    description: {
      fontSize: theme.typography.fontSize - 2,
      fontWeight: theme.typography.fontWeight,
      color: theme.colors.baseContrast050
    },
    small: {
      height: 36
    },
    medium: {
      height: 40
    },
    large: {
      height: 48
    },
    textarea: {
      height: "auto"
    },
    // with prefix the border side is shifted to the prefix from the input side
    inputHasPrefix: {
      borderInlineStartColor: theme.colors.baseContrast060,
      borderInlineStartWidth: 1
    },
    // with suffix the border side is shifted to the suffix from the input side
    inputHasSuffix: {
      borderInlineEndColor: theme.colors.baseContrast060,
      borderInlineEndWidth: 1
    },
    inputPrefixSuffixValid: {},
    inputPrefixSuffixInvalid: {}
  };
};
var useTextInputStyles = exports.useTextInputStyles = (0, _createUseStyles.default)(styles, {
  name: "TextInput"
});